import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Transition as _Transition, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = {
  class: "header modulewrap"
};
const _hoisted_2 = {
  class: "topwrap"
};
const _hoisted_3 = {
  class: "logo"
};
const _hoisted_4 = {
  href: "/"
};
const _hoisted_5 = {
  class: "topmenu"
};
const _hoisted_6 = {
  class: "topnav realwrap"
};
const _hoisted_7 = ["onMouseover"];
const _hoisted_8 = {
  class: "nav1"
};
const _hoisted_9 = {
  key: 0,
  class: "nav2"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "navarrow"
}, null, -1);
const _hoisted_11 = {
  class: "langinfo"
};
const _hoisted_12 = {
  class: "navsmall"
};
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-caidan"
}, null, -1);
const _hoisted_14 = [_hoisted_13];
const _hoisted_15 = {
  class: "navinfo"
};
const _hoisted_16 = {
  class: "sidelang"
};
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "topnavwrap"
}, null, -1);
const _hoisted_18 = {
  class: "banner"
};
const _hoisted_19 = {
  key: 0,
  class: "sloganwrap"
};
const _hoisted_20 = {
  class: "realwrap"
};
const _hoisted_21 = ["innerHTML"];
const _hoisted_22 = {
  key: 0,
  class: "navsub"
};
const _hoisted_23 = ["innerHTML"];
const _hoisted_24 = {
  class: "navsubbox"
};
const _hoisted_25 = {
  class: "navsubcurtitle"
};
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "navsubcurarrow"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-zhankai"
})], -1);
const _hoisted_27 = {
  key: 1,
  class: "navsubbox"
};
const _hoisted_28 = {
  class: "navsubcurtitle"
};
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "navsubcurarrow"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-zhankai"
})], -1);
export default {
  __name: 'Cheader',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const FFdata = reactive({
      navIdOver: 0,
      isShowNav: false,
      isShowSub: false,
      isScroll: false //是否滚动，调整顶部导航
    });

    const CnavList = computed(() => proxy.$store.navList);
    const Cnav = computed(() => {
      let _nav = {};
      if (proxy.$common.basic.isArrayExist(CnavList.value)) {
        let navKv = proxy.$store.navKv;
        let navIdSub = proxy.$store.navIdSub;
        if (navKv > 0) {
          _nav = proxy.$common.basic.jsonClone(proxy.$common.basic.FFfind(CnavList.value, 'kv', navKv));
          if (navIdSub > 0) {
            let _navSub = proxy.$common.basic.FFfind(_nav.x_children, 'id', navIdSub);
            if (proxy.$common.basic.isObjExist(_navSub)) {
              if (_navSub.pid == _nav.id) {
                if (_navSub.banner) {
                  _nav.banner = _navSub.banner;
                  _nav.imgs = '';
                }
                if (_navSub.imgs) {
                  _nav.imgs = _navSub.imgs;
                }
              }
            }
          }
        }
      }
      return _nav;
    });
    const CnavSub = computed(() => {
      let _navsub = {};
      if (proxy.$common.basic.isObjExist(Cnav.value)) {
        if (proxy.$common.basic.isArrayExist(Cnav.value.x_children)) {
          _navsub = proxy.$common.basic.FFfind(Cnav.value.x_children, 'id', proxy.$store.navIdSub);
        }
      }
      return _navsub;
    });
    const headerScroll = () => {
      let scrolltop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      FFdata.isScroll = scrolltop > 120;
    };
    const setLang = v => {
      proxy.$store.SET_LANGCUR(v);
      hideNav();
    };
    const hideNav = () => {
      FFdata.isShowNav = false;
    };
    const hideNavSub = () => {
      FFdata.isShowSub = false;
    };
    onMounted(() => {
      window.addEventListener('scroll', headerScroll, false);
    });
    onUnmounted(() => {
      window.removeEventListener('scroll', headerScroll, false);
    });
    return (_ctx, _cache) => {
      const _component_ffimg = _resolveComponent("ffimg");
      const _component_router_link = _resolveComponent("router-link");
      const _component_ffswiper = _resolveComponent("ffswiper");
      const _directive_Clickoutside = _resolveDirective("Clickoutside");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: _normalizeClass(['topinfo', _unref(FFdata).isScroll ? 'topfixed' : ''])
      }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("a", _hoisted_4, [_createVNode(_component_ffimg, {
        alias: "telfort_logo"
      })])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CnavList), item => {
        return _openBlock(), _createElementBlock("div", {
          class: "topnavitem",
          key: item.id,
          onMouseover: $event => _unref(FFdata).navIdOver = item.id,
          onMouseout: _cache[0] || (_cache[0] = $event => _unref(FFdata).navIdOver = 0)
        }, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_router_link, {
          to: item.url,
          class: _normalizeClass({
            cs: _ctx.$store.navKv == item.kv
          })
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$common.langInfo(item.title, item.title_en)), 1)]),
          _: 2
        }, 1032, ["to", "class"])]), _createVNode(_Transition, {
          name: "slidedown"
        }, {
          default: _withCtx(() => [item.x_children.length > 0 ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [_hoisted_10, _createElementVNode("dl", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.x_children, item2 => {
            return _openBlock(), _createElementBlock("dd", {
              key: item2.id
            }, [_createVNode(_component_router_link, {
              to: item2.url,
              class: "overdot"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$common.langInfo(item2.title, item2.title_en)), 1)]),
              _: 2
            }, 1032, ["to"])]);
          }), 128))])], 512)), [[_vShow, item.id == _unref(FFdata).navIdOver]]) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)], 40, _hoisted_7);
      }), 128))])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("a", {
        href: "#",
        class: _normalizeClass({
          cs: _ctx.$store.langCur == 1
        }),
        onClick: _cache[1] || (_cache[1] = $event => setLang(1))
      }, "中文", 2), _createTextVNode(" | "), _createElementVNode("a", {
        href: "#",
        class: _normalizeClass({
          cs: _ctx.$store.langCur == 2
        }),
        onClick: _cache[2] || (_cache[2] = $event => setLang(2))
      }, "EN", 2)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", {
        class: "navmenu",
        onClick: _cache[3] || (_cache[3] = $event => _unref(FFdata).isShowNav = !_unref(FFdata).isShowNav)
      }, _hoisted_14), _createVNode(_Transition, {
        name: "fade"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_15, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CnavList), (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            key: item.id
          }, [_createVNode(_component_router_link, {
            class: _normalizeClass({
              cs: _ctx.$store.navKv == item.kv
            }),
            to: item.url,
            onClick: hideNav
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$common.langInfo(item.title, item.title_en)), 1)]),
            _: 2
          }, 1032, ["class", "to"])]);
        }), 128)), _createElementVNode("li", _hoisted_16, [_createElementVNode("a", {
          href: "#",
          class: _normalizeClass({
            cs: _ctx.$store.langCur == 1
          }),
          onClick: _cache[4] || (_cache[4] = $event => setLang(1))
        }, "中文", 2), _createTextVNode(" | "), _createElementVNode("a", {
          href: "#",
          class: _normalizeClass({
            cs: _ctx.$store.langCur == 2
          }),
          onClick: _cache[5] || (_cache[5] = $event => setLang(2))
        }, "EN", 2)])])], 512), [[_vShow, _unref(FFdata).isShowNav]])]),
        _: 1
      })])), [[_directive_Clickoutside, hideNav]])], 2), _hoisted_17]), _ctx.$common.basic.isObjExist(_unref(Cnav)) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_ffswiper, {
        imgs: _unref(Cnav).imgs || _unref(Cnav).banner
      }, null, 8, ["imgs"]), _unref(Cnav).subtitle || _unref(Cnav).subtitle_en ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", {
        class: "slogan",
        innerHTML: _ctx.$common.langInfo(_ctx.$common.basic.FFreplaceAll(_unref(Cnav).subtitle, ',', '<br />'), _ctx.$common.basic.FFreplaceAll(_unref(Cnav).subtitle_en, ',', '<br />'))
      }, null, 8, _hoisted_21)])])) : _createCommentVNode("", true)]), _ctx.$common.basic.isArrayExist(_unref(Cnav).x_children) ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_unref(Cnav).content || _unref(Cnav).content_en ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", {
        class: "navsubcon realwrap",
        innerHTML: _ctx.$common.langInfo(_unref(Cnav).content, _unref(Cnav).content_en)
      }, null, 8, _hoisted_23), _createElementVNode("div", _hoisted_24, [_withDirectives((_openBlock(), _createElementBlock("div", {
        class: "navsubcur",
        onClick: _cache[6] || (_cache[6] = $event => _unref(FFdata).isShowSub = true)
      }, [_createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$common.langInfo(_unref(CnavSub).title, _unref(CnavSub).title_en)), 1), _hoisted_26])), [[_directive_Clickoutside, hideNavSub]]), _createElementVNode("dl", {
        class: _normalizeClass(['realwrap', 'hascon', _unref(FFdata).isShowSub ? 'navshow' : ''])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Cnav).x_children, item => {
        return _openBlock(), _createElementBlock("dd", {
          key: item.id
        }, [_createVNode(_component_router_link, {
          to: item.url || _ctx.Citemurl + '/' + item.id,
          class: _normalizeClass(['overdot', _ctx.$store.navIdSub == item.id ? 'cs' : ''])
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$common.langInfo(item.title, item.title_en)), 1)]),
          _: 2
        }, 1032, ["to", "class"])]);
      }), 128))], 2)])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_27, [_withDirectives((_openBlock(), _createElementBlock("div", {
        class: "navsubcur",
        onClick: _cache[7] || (_cache[7] = $event => _unref(FFdata).isShowSub = true)
      }, [_createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$common.langInfo(_unref(CnavSub).title, _unref(CnavSub).title_en)), 1), _hoisted_29])), [[_directive_Clickoutside, hideNavSub]]), _createElementVNode("dl", {
        class: _normalizeClass(['realwrap', _unref(FFdata).isShowSub ? 'navshow' : ''])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Cnav).x_children, item => {
        return _openBlock(), _createElementBlock("dd", {
          key: item.id
        }, [_createVNode(_component_router_link, {
          to: item.url || _ctx.Citemurl + '/' + item.id,
          class: _normalizeClass(['overdot', _ctx.$store.navIdSub == item.id ? 'cs' : ''])
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$common.langInfo(item.title, item.title_en)), 1)]),
          _: 2
        }, 1032, ["to", "class"])]);
      }), 128))], 2)]))])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]);
    };
  }
};